module.exports = __webpack_public_path__ + "img/board-navigation.473c5b15.png";